import Vue from 'vue';
import { VContainer, VAlert } from 'vuetify/lib';

export default Vue.extend({
  render() {
    return (
      <VContainer>
        <VAlert type='warning'>Not found.</VAlert>
      </VContainer>
    );
  },
});
